import { render, staticRenderFns } from "./CustomerStatementCriteria.vue?vue&type=template&id=d9bd4406"
import script from "./CustomerStatementCriteria.vue?vue&type=script&lang=js"
export * from "./CustomerStatementCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports